<script>
import Avatar from './Avatar';
import GroupAvatar from './GroupAvatar';
import {
  ACL_TYPE_GROUP,
  ACL_TYPE_USER,
} from '../../constants/backendConstants';

export default {
  name: 'ACLAvatar',
  components: {
    Avatar,
    GroupAvatar,
  },
  props: {
    accessor: {
      type: Object,
      required: true,
    },
    avatarProps: {
      type: Object,
      default: () => ({}),
    },
  },
  render(createElement) {
    switch (this.accessor.entityType) {
      case ACL_TYPE_GROUP:
        return createElement(
          GroupAvatar,
          {
            props: {
              groupId: this.accessor.entityId,
              name: this.accessor.displayName,
              ...this.avatarProps,
            },
          },
        );
      case ACL_TYPE_USER:
        return createElement(
          Avatar,
          {
            props: {
              userId: this.accessor.entityId,
              ...this.avatarProps,
            },
          },
        );
      default:
        throw Error(`Unknown entityType ${this.accessor.entityType}`);
    }
  },
};
</script>
